<template>
<div class="body-contact home-background">
  <div  class="bigbox position-absolute top-50 start-50 translate-middle "  >
    <br>
   
    <div><h1 style="color:#F9CB40; margin-left:40px;font-family:Times New Roman;">About me</h1></div>
          <div>
             <p style="color:white; margin-left:40px;"> I am an undergraduate student at Sri Lanka Institute of Information Technology (SLIITT)<br>
              following a degree in Information Technology specializing in information technology.<br> 
              I am currently in the 3rd year 1st semester of my degree program.<br>
              I am responsible and hardworking individual, and I believe that I am a good team player .<br> </p>
          </div>
          <div>
            <code><img width="15%" src="https://www.vectorlogo.zone/logos/java/java-vertical.svg"></code>
            <code><img width="15%" src="https://www.vectorlogo.zone/logos/reactjs/reactjs-ar21.svg"></code>
            <code><img width="15%" src="https://www.vectorlogo.zone/logos/springio/springio-ar21.svg"></code>
            <code><img width="15%" src="https://www.vectorlogo.zone/logos/vuejs/vuejs-ar21.svg"></code>
            <code><img width="15%" src="https://www.vectorlogo.zone/logos/nodejs/nodejs-ar21.svg"></code>
            <code><img width="15%" src="https://www.vectorlogo.zone/logos/android/android-ar21.svg"></code>
          </div>
  </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
/* .body-contact {
  min-height: calc(100vh - 56px);
  background-size: cover;
  background-image: url("../assets/bg55.jpg");
  z-index: 1000;
} */
.home-background {
    position: relative;
    background: #C4C4C477;
    height: 91.5%;
    z-index: 1000;
}

.bigbox {
 background-color:#00000090;
 height:500px;
 width:1000px;
 z-index: 1000;
}
</style>